import { CREEPS_PER_WAVE, ENDLESS, FLY_WAVES, LAST_WAVE, SUPERFAST } from '../data/balance.js';
import type { WaveDef } from './types.js';

/**
 * Wave definition for wave n. Pure. Waves 1..LAST_WAVE use formulas identical
 * to the prototype -- the pre-endless corpus and leaderboard depend on them.
 * Past LAST_WAVE the endless extrapolation applies (ADR 0007, modeled in
 * playtests/endless-scaling.md): HP continues from the wave-50 value at a
 * gentler growth factor, cadences continue, and every 50th wave is a mega
 * boss.
 */
export function waveDef(n: number): WaveDef {
  const flying = FLY_WAVES.has(n) || (n > 50 && n % 7 === 1);
  const boss = n % 10 === 0;
  const mega = n > LAST_WAVE && n % ENDLESS.MEGA_EVERY === 0;
  let hp =
    n <= LAST_WAVE
      ? 5 * Math.pow(1.2, n - 1) * (n > 5 ? 3 : 1)
      : 5 * Math.pow(1.2, LAST_WAVE - 1) * 3 * Math.pow(ENDLESS.HP_GROWTH, n - LAST_WAVE);
  let speed = 2.2;
  let count = CREEPS_PER_WAVE;
  const tags: string[] = [];
  if (SUPERFAST.has(n) || (n > LAST_WAVE && n % 10 === ENDLESS.SUPERFAST_DIGIT)) {
    speed = 3.4;
    tags.push('FAST!');
  } else if (n % 4 === 0) {
    speed = 2.8;
    tags.push('fast');
  }
  if (flying) {
    hp *= 0.75;
    speed = Math.max(speed, 2.6);
    tags.push('FLYING');
  }
  if (mega) {
    hp *= ENDLESS.MEGA_HP_MULT;
    count = 1;
    speed = ENDLESS.MEGA_SPEED;
    tags.push('MEGA BOSS');
  } else if (boss) {
    hp *= 8;
    count = 1;
    speed = 1.8;
    tags.push('BOSS');
  }
  const armor = n >= 11 ? Math.floor((n - 10) / 3) + 1 : 0;
  if (armor) tags.push(`${armor} armor`);
  return {
    flying,
    boss,
    mega,
    hp: Math.round(hp),
    speed,
    count,
    armor,
    tags,
    bounty:
      Math.max(1, Math.round(1 + n * 0.4)) * (mega ? ENDLESS.MEGA_BOUNTY_MULT : boss ? 10 : 1),
  };
}
